import {lazy} from 'react';

const CampaignManagement = lazy(() => import('./CampaignManagement'));

export default CampaignManagement;
